import { ReactNode } from 'react';
import { mreTheme } from './theme';
import { GetBrandTheme } from '@leadflow/shared/theme/GetBrandTheme';

const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  return <GetBrandTheme brandTheme={mreTheme}>{children}</GetBrandTheme>;
};

export default ThemeProviderWrapper;
